module.exports = __webpack_public_path__ + "media/images/lb/521-e2e5277fd70db2721a963c25ff0c990a.svg";